var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataOrigin.state === 'warning')?_c('div',{staticClass:"warning"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }